import { CommonService, RepairOrderQuotePartSubmitModel, RepairOrderQuoteSubmitModel } from 'api-new/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type RepairOrderQuotePartInput = {
  id: number;
  requestBody?: RepairOrderQuotePartSubmitModel;
};

export const useCommonRepairOrderQuotePartMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof CommonService.postCommonRepairOrderQuotePart>>,
      QueryError,
      RepairOrderQuotePartInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ id, requestBody }: RepairOrderQuotePartInput) => {
      return CommonService.postCommonRepairOrderQuotePart(id, requestBody);
    },
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully updated!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
